import script from "./DetailRequestKeypad.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailRequestKeypad.vue?vue&type=script&setup=true&lang=js"

import "./DetailRequestKeypad.vue?vue&type=style&index=0&id=36f21fd5&lang=scss&scoped=true"
import "./DetailRequestKeypad.vue?vue&type=style&index=1&id=36f21fd5&lang=scss"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36f21fd5"]])

export default __exports__